import { ReactNode } from 'react';
import { useThemeColor } from '@/hooks/useThemeColor';

interface SectionTitleProps {
    title: string;
    subTitle?: string;
    action?: ReactNode;
}

export default function SectionTitle({ title, subTitle, action }: SectionTitleProps) {
    const { scheme } = useThemeColor();
    return (
        <>
            <div
                className={`flex justify-start ${
                    action ? 'flex-wrap items-center gap-y-1' : ''
                } ${scheme?.text} w-full border-b border-color-base tracking-wide min-h-[30px] select-none`}
            >
                <span className="flex items-center font-cantarell font-bold text-sm">{title}</span>
                {subTitle && (
                    <span className="flex items-center pl-1 font-notojp font-medium text-gray-500 text-xs">
                        {subTitle}
                    </span>
                )}
                {action && <div className="flex items-center ml-auto pl-2 shrink-0">{action}</div>}
            </div>
        </>
    );
}
